import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Button from 'material-ui/Button';
import classNames from 'classnames';
import * as URI from "urijs";
import { connect } from 'react-redux';
import { isSalesDemo } from "../../../utils/userUtils";

const styles = () => ({
  link: {
    color: "#1A65FF",
    textDecoration: 'underline',
    marginRight: 20,
    cursor: 'pointer',
    whiteSpace: 'nowrap',
  },

  btn: {
    padding: '10px 18px',
    height: "33px",
    minWidth: "118px",
    borderRadius: "2px",
    fontSize: "13px",
    textTransform: 'none',
    whiteSpace: 'nowrap',
    display: 'block',
  },

  btnEnable: {
    border: "1px solid #1A65FF",
    background: "#FFFFFF",
    color: "#1A65FF",
    "&:hover": {
      background: "#1A65FF",
      color: '#FFFFFF',
    },
  },
});

class DownloadButtons extends React.Component {
  handleDownloadFile = (id, isAdditionalFile) => {
    const query = {
      is_additional_file: isAdditionalFile
    };
    let path = `letter-orders/${id}/download`;

    let url = URI(process.env.REACT_APP_API_BASE_URL + path);
    url = url.query(query);
    window.open(url);
  };

  handleDownloadProofreadFile = (id) => {
    let query = {};
    let path = isSalesDemo(this.props.user) ? `letter-orders/dummy_proofread_download` : `letter-orders/${id}/proofread/download`;

    let url = URI(process.env.REACT_APP_API_BASE_URL + path);
    url = url.query(query);
    window.open(url);
  };

  render() {
    const { classes, user, item, isAnchorTag } = this.props;

    const Tag = isAnchorTag ? 'a' : Button;

    const addMargin = 10;
    return (
      <React.Fragment>
        <Tag
          className={(isAnchorTag) ? classes.link : classNames(classes.btn, classes.btnEnable)}
          onClick={() => this.handleDownloadFile(item.id, false)}
        >
          注文データDL
        </Tag>
        {!!item.additional_file_path && (
          <Tag
            className={(isAnchorTag) ? classes.link : classNames(classes.btn, classes.btnEnable)}
            onClick={() => this.handleDownloadFile(item.id, true)}
            style={{ marginTop: (isAnchorTag) ? "" : addMargin }}
          >
            添付物DL
          </Tag>
        )}
        {(!!(isSalesDemo(user)) || (!!(user && user.can_confirm_proofreading_data && item.proofread_path))) && (
          <Tag
            className={(isAnchorTag) ? classes.link : classNames(classes.btn, classes.btnEnable)}
            // デモアカウントはダミーの校了データダウンロードを行う 校了データ確認オプション有効なユーザで校了データ作成済みの場合はリンクを表示
            onClick={() => this.handleDownloadProofreadFile(item.id)}
            style={{ marginTop: (isAnchorTag) ? "" : addMargin }}
          >
            校了データDL
          </Tag>
        )}
      </React.Fragment>
    )
  }
}

DownloadButtons.defaultProps = {
  isAnchorTag: true,
}

DownloadButtons.propTypes = {
  classes: PropTypes.object.isRequired,
  item: PropTypes.object.isRequired,
  isAnchorTag: PropTypes.bool,
  user: PropTypes.object,
};

const mapStateToProps = (state) => {
  return {
    user: state.accountSetting.user,
  };
};

export default withStyles(styles)(connect(
  mapStateToProps
)(DownloadButtons));



// WEBPACK FOOTER //
// ./src/components/OrderList/parts/DownloadButtons.jsx